function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20 19.4888C18.9867 19.4888 18.08 19.8888 17.3867 20.5154L7.88 14.9821C7.94667 14.6754 8 14.3688 8 14.0488C8 13.7288 7.94667 13.4221 7.88 13.1154L17.28 7.63542C18 8.30209 18.9467 8.71542 20 8.71542C22.2133 8.71542 24 6.92876 24 4.71542C24 2.50209 22.2133 0.715424 20 0.715424C17.7867 0.715424 16 2.50209 16 4.71542C16 5.03542 16.0533 5.34209 16.12 5.64876L6.72 11.1288C6 10.4621 5.05333 10.0488 4 10.0488C1.78667 10.0488 0 11.8354 0 14.0488C0 16.2621 1.78667 18.0488 4 18.0488C5.05333 18.0488 6 17.6354 6.72 16.9688L16.2133 22.5154C16.1467 22.7954 16.1067 23.0888 16.1067 23.3821C16.1067 25.5288 17.8533 27.2754 20 27.2754C22.1467 27.2754 23.8933 25.5288 23.8933 23.3821C23.8933 21.2354 22.1467 19.4888 20 19.4888Z",
  fill: "#424242"
});

function SvgShare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 28,
    viewBox: "0 0 24 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgShare);
export default __webpack_public_path__ + "static/media/share.48c9cef0.svg";
export { ForwardRef as ReactComponent };